// OrderActionButtons.js

import { useState } from 'react';
import { Button as MuiButton } from '@mui/material';
import { useRecordContext } from 'react-admin';
import { ApprovalDialog, DisapprovalDialog } from './ApprovalDialog';

// --- 承認ボタンコンポーネント ---
export const ApproveButton = () => {
  const record = useRecordContext();
  const [isDialogOpen, setDialogOpen] = useState(false);

  const handleClick = () => {
    setDialogOpen(true);
  };

  const handleClose = () => {
    setDialogOpen(false);
  };

  return (
    <>
      <MuiButton
        onClick={handleClick}
        size="small"
        variant="contained"
        sx={{
          backgroundColor: '#6BBF8E', // 黄緑
          color: 'white',
          display: 'inline-flex',
          alignItems: 'center',
          '&:hover': {
            backgroundColor: '#5AAE7E'
          }
        }}
      >
        承認
      </MuiButton>
      {isDialogOpen && <ApprovalDialog open={isDialogOpen} onClose={handleClose} selectedId={record.id} />}
    </>
  );
};

// --- 否認ボタンコンポーネント ---
export const DisapproveButton = () => {
  const record = useRecordContext();
  const [isDialogOpen, setDialogOpen] = useState(false);

  const handleClick = () => {
    setDialogOpen(true);
  };

  const handleClose = () => {
    setDialogOpen(false);
  };

  return (
    <>
      <MuiButton
        onClick={handleClick}
        size="small"
        variant="contained"
        sx={{
          backgroundColor: '#F28C7C', // オレンジ
          color: 'white',
          display: 'inline-flex',
          alignItems: 'center',
          '&:hover': {
            backgroundColor: '#e87a6b'
          }
        }}
      >
        否認
      </MuiButton>
      {isDialogOpen && <DisapprovalDialog open={isDialogOpen} onClose={handleClose} selectedIds={[record.id]} />}
    </>
  );
};
